import React, { useMemo } from 'react'
import CtInspectionType from './CtInspectionType'
import CtModal from './CtModal'
import CtModalUnit from './CtModalUnit'
import CtInspInterval from './CtInspInterval'
import CtInspUnitComment from './CtInspComments'
import CtInspUnitOverride from './CtInspOverride'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

export const CtInspectionContainer = ({ actionPermits, envConfig }) => {
  const ctInspection = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CT_INSPECTION_ADMIN,
          ScreenPermissions.CT_INSPECTION_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {ctInspection && (
        <React.Fragment>
          <Route exact path="/ct-modal" component={CtModal} />
          <Route exact path="/ct-modal-unit" component={CtModalUnit} />
          <Route
            exact
            path="/ct-inspection-type"
            component={CtInspectionType}
          />
          <Route
            exact
            path="/ct-inspection-interval"
            component={CtInspInterval}
          />
          <Route
            exact
            path="/ct-inspection-unit-comment"
            component={CtInspUnitComment}
          />
          <Route
            exact
            path="/ct-inspection-unit-override"
            component={CtInspUnitOverride}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
